const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const englishDigits = "0123456789";

export const toEnglishDigits = (string_: string) =>
  string_.replaceAll(
    /[۰-۹]/g,
    (ch) => englishDigits[persianDigits.indexOf(ch)]
  );
